import EmptyState from "../store/emptyState";
import { RealityCheckActionConstants } from "../action-constants";
import globalReducerHelper from "./globalReducerHelper";

const { SHOW_POPUP, HIDE_POPUP } = RealityCheckActionConstants;

const realityCheck = (state = EmptyState.realityCheck, action) => {
  if (!state) return {};

  const { type, payload } = action;

  switch (type) {
    case SHOW_POPUP: {
      return Object.assign({}, state, {
        show: true,
        netLossAmount: action.payload
      });
    }
    case HIDE_POPUP: {
      return Object.assign({}, state, {
        show: false,
        netLossAmount: null
      });
    }

    default:
      return globalReducerHelper(
        state,
        type,
        payload && payload.realityCheck,
        EmptyState.realityCheck
      );
  }
};

export default realityCheck;
